import { Button, Grid } from '@mui/material';
import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

interface PropsType {
  onCancel: () => void;
  onConfirm: () => void;
  disabled?: boolean;
}

export default function Actions({ onCancel, onConfirm, disabled }: PropsType) {
  return (
    <Grid container justifyContent="space-between" alignItems="center" spacing={1} mt={0.5}>
      <Grid item xs={6} title="Cancel">
        <Button
          fullWidth
          size="small"
          variant="outlined"
          onClick={onCancel}
          startIcon={<CloseIcon sx={{ fontSize: 16 }} />}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.8rem',
            py: 0.6,
            color: 'text.secondary',
            borderColor: 'divider',
            bgcolor: '#fff',
            '&:hover': {
              borderColor: 'text.primary',
              bgcolor: 'action.hover',
            },
          }}
        >
          Cancel
        </Button>
      </Grid>
      <Grid item xs={6} title="Save">
        <Button
          fullWidth
          size="small"
          variant="contained"
          color="primary"
          onClick={onConfirm}
          disabled={disabled}
          startIcon={<CheckIcon sx={{ fontSize: 16 }} />}
          sx={{
            borderRadius: '8px',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.8rem',
            py: 0.6,
            boxShadow: 'none',
            '&:hover': {
              boxShadow: 'none',
            },
          }}
        >
          Save
        </Button>
      </Grid>
    </Grid>
  );
}
